// ios 禁止缩放问题
// 阻止双击放大

// eslint-disable-next-line no-unused-vars
var globalThis; // 此代码为qq浏览器配置，以免报错

var lastTouchEnd = 0;
document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
        event.preventDefault();
    }
});
document.addEventListener('touchend', function(event) {
    var now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
        event.preventDefault();
    }
    lastTouchEnd = now;
}, false);

// 阻止双指放大
document.addEventListener('gesturestart', function(event) { event.preventDefault(); });